import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetStressAssessmentSummary } from '~/usecases/useGetStressAssessmentSummary';

type Args = {
  stressAssessmentId: number;
};
type IUseStressAssessmentReportBreadcrumb = (args: Args) => {
  data: ReturnType<typeof useGetStressAssessmentSummary>['data'];
};

export const useStressAssessmentReportBreadcrumb: IUseStressAssessmentReportBreadcrumb = ({
  stressAssessmentId,
}) => {
  const threeLetterCode = getThreeLetterCode();
  const { data } = useGetStressAssessmentSummary(threeLetterCode, stressAssessmentId.toString());

  return {
    data,
  };
};
